import _ from "underscore";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";

import React from "react";
import classNames from "classnames";
import BasicUtils from "../../utils/basic-utils";
import Icon from "../elements/icon";
import Button from "../elements/button";

const MAX_VISIBLE = 5;
const NUM_CONTROL = 3;
const PLACEHOLDER = "...";

export default class Pagination extends React.Component {
  static displayName = "Pagination";

  static propTypes = {
    page: PropTypes.number,
    total: PropTypes.number, // total number of pages
    onChange: PropTypes.func.isRequired,
    color: PropTypes.string,
  };

  handlePageChange = (page) => {
    if (!_.isNumber(page)) {
      return;
    }
    page = this.toValidPage(page);
    if (page !== this.props.page) {
      return typeof this.props.onChange === "function" ? this.props.onChange(page) : undefined;
    }
  };

  toValidPage = (page) => {
    page = BasicUtils.toNumber(page);
    page = Math.max(page, 1);
    return (page = Math.min(page, this.toValidTotal(this.props.total)));
  };

  toValidTotal = (total) => {
    return (total = Math.max(1, Math.ceil(total)));
  };

  getVisiblePages = () => {
    if (this.props.total <= MAX_VISIBLE) {
      return _.range(1, this.props.total + 1);
    } else if (this.props.page < NUM_CONTROL) {
      return _.range(1, MAX_VISIBLE + 1);
    } else {
      const max_value = Math.min(this.props.page + NUM_CONTROL, Math.ceil(this.props.total)) + 1;
      const min_value = max_value - NUM_CONTROL - 1;
      return _.flatten([1, PLACEHOLDER, _.range(min_value, max_value)]);
    }
  };

  render() {
    if (!this.props.page || !this.props.total) {
      return null;
    }

    const page = this.toValidPage(this.props.page);
    const total = this.toValidTotal(this.props.total);
    if (total === 1) {
      return null;
    }

    const visible_pages = this.getVisiblePages();
    const has_placeholder = _.contains(visible_pages, PLACEHOLDER);

    const activeStyle = {
      backgroundColor: this.props.color,
      borderColor: this.props.color,
    };

    return (
      <ul className={classNames("et--pagination", this.props.className)}>
        <li className="et--pagination--item">
          <Button
            disabled={page === 1}
            type="simple"
            label="Previous Page"
            className="et--pagination--prev"
            onClick={() => this.handlePageChange(page - 1)}
          >
            <Icon icon="chevron-left" />
          </Button>
        </li>
        {_.map(visible_pages, (num) => {
          return (
            <li
              key={num}
              className={classNames("et--pagination--item", {
                "et--pagination--placeholder": num === PLACEHOLDER,
                "et--pagination--initial": has_placeholder && num === 1,
                "et--pagination--first": num === 1 || (has_placeholder && num === this.props.page),
                "et--pagination--last": num === _.last(visible_pages),
                "is-active": this.props.page === num,
              })}
              onClick={() => this.handlePageChange(num)}
              style={this.props.page === num ? activeStyle : undefined}
            >
              {num}
            </li>
          );
        })}
        <li className="et--pagination--item">
          <Button
            disabled={page === total}
            type="simple"
            label="Next Page"
            className="et--pagination--next"
            onClick={() => this.handlePageChange(page + 1)}
          >
            <Icon icon="chevron-right" />
          </Button>
        </li>
      </ul>
    );
  }
}
